import React, { useEffect, useState } from "react";
import Link from "../../../styles/components/Link";
import { Flex, MainInner } from "@/styles/global";
import { Body } from "@/styles/typography";
import Icon from "../../../styles/components/Icon";
import useBreadcrumbData from "@/components/global-components/Breadcrumbs/useBreadcrumbData";

type Crumb = {
  label: string;
  link: string;
};

const Breadcrumbs: React.FC = () => {
  const [crumbs, setCrumbs] = useState<Crumb[]>([]);
  const data = useBreadcrumbData();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const crumbs: Crumb[] = [];

    let currentPage = data.find(
      (page) => page.uri === window.location.pathname
    );

    while (currentPage) {
      if (currentPage?.title && currentPage?.uri) {
        crumbs.push({ label: currentPage.title, link: currentPage.uri });
      }
      currentPage =
        data.find((page) => page.id === currentPage?.parentId) || undefined;
    }

    crumbs.push({
      label: "Start",
      link: "/",
    });

    setCrumbs(crumbs.toReversed());
  }, [data]);

  return (
    <>
      <MainInner>
        <Flex $align="center" $margin="12px 0" $wrap="wrap">
          {crumbs.map((crumb, i) => {
            const isLastCrumb = i === crumbs.length - 1;

            if (isLastCrumb) {
              return (
                <Body color="textBlack" size={16} key={i}>
                  {crumb.label}
                </Body>
              );
            }

            return (
              <Flex key={i} $gap={12} $center>
                <Link url={crumb.link}>
                  <Body color="black" size={16}>
                    {crumb.label}
                  </Body>
                </Link>
                <Icon
                  src="ChevronRight"
                  color="black"
                  width={13}
                  margin="0 12px 0 0"
                />
              </Flex>
            );
          })}
        </Flex>
      </MainInner>
    </>
  );
};

export default Breadcrumbs;
